import React from "react"
import { Box } from "theme-ui"
import Footer from "./footer"
import Header from "./header"

const Layout = ({ children, style = {} }) => {
  return (
    <React.Fragment>
      <Header />
      <Box as="main" variant="layout.main" sx={style}>
        {children}
      </Box>
      <Footer />
    </React.Fragment>
  )
}

export default Layout
